/**
 * @fileoverview GET handler for the "/companies/:company_id/custom_roles/custom_role/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdCustomRolesCustomRoleId } from "./constants";
import type { CompaniesCompanyIdCustomRolesCustomRoleIdResult } from "./types";

export const getCompaniesCompanyIdCustomRolesCustomRoleId = reactQueryFetcherAdapter(
  companiesCompanyIdCustomRolesCustomRoleId,
  (
    signal: AbortSignal,
    companyId: string,
    id: string
  ): Promise<CompaniesCompanyIdCustomRolesCustomRoleIdResult> => {
    return fetch(`/companies/${companyId}/custom_roles/custom_role/${id}`, "GET", {}, { signal });
  }
);
